import React from 'react';
import { Box, Grid } from '@mui/material';

import {
  Container,
  SectionTitle,
  FieldLabel,
  FieldValue,
} from './styles';

interface DetailItemProps {
  label: string;
  value: string;
}

const DetailItem: React.FC<DetailItemProps> = ({ label, value }) => (
  <Box>
    <FieldLabel>{label}</FieldLabel>
    <FieldValue>{value}</FieldValue>
  </Box>
);

interface ShiftDetailsProps {
  title?: string;
  date: string;
  position: string;
  startTime: string;
  endTime: string;
  numberOfWorkers: string;
  experience: number | string;
  shiftManager?: string;
  additionalNotes?: string;
  shift_id?: number | null;
}

const ShiftDetails: React.FC<ShiftDetailsProps> = ({
  title,
  date,
  position,
  startTime,
  endTime,
  numberOfWorkers,
  experience,
  shiftManager,
  additionalNotes,
  shift_id
}) => {

  return (
    <Container>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <SectionTitle>Shift Details</SectionTitle>
      </Box>

      <Grid container spacing={3}>
        {title && (
          <Grid size={{ xs: 12, md: 6 }}>
            <DetailItem label="Shift Title" value={title} />
          </Grid>
        )}
        {shiftManager && (
          <Grid size={{ xs: 12, md: 6 }}>
            <DetailItem label="Shift Manager" value={shiftManager} />
          </Grid>
        )}
        <Grid size={{ xs: 12, md: 6 }}>
          <DetailItem label="Scheduled Start Time" value={startTime} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <DetailItem label="Scheduled End Time" value={endTime} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <DetailItem label="Role" value={position} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <DetailItem label="No of Workers" value={numberOfWorkers} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <DetailItem label="Experience Required" value={String(experience)} />
        </Grid>
        {additionalNotes && (
          <Grid size={12}>
            <DetailItem label="Additional Notes" value={additionalNotes} />
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default ShiftDetails;
